import { types as modalTypes } from 'modules/quotes/quoteItems/modals/Operation/data/actions';

import { types } from './actions';

const initialState = {
  componentId: null,
  isFetching: false,
  quoteItemId: null,
  realTimeMaterialPricing: {},
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case modalTypes.OPEN_OPERATION_MODAL:
      return {
        ...state,
        componentId: payload.operation.componentId,
        quoteItemId: payload.quoteItemId,
      };
    case modalTypes.CLOSE_OPERATION_MODAL:
      return {
        ...state,
        componentId: null,
        isFetching: false,
        quoteItemId: null,
        realTimeMaterialPricing: {},
      };
    case types.REALTIME_MATERIAL_PRICING_REQUEST:
      return {
        ...state,
        isFetching: true,
        isRound: payload.isRound,
      };
    case types.REALTIME_MATERIAL_PRICING_SUCCESS:
      return {
        ...state,
        isFetching: false,
        realTimeMaterialPricing: payload,
      };
    case types.REALTIME_MATERIAL_PRICING_ERROR:
      return {
        ...state,
        isFetching: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.quotes.materialPricing;

export const getComponentId = (state) => getScope(state).componentId;

export const getIsFetching = (state) => getScope(state).isFetching;

export const getQuoteItemId = (state) => getScope(state).quoteItemId;

export const getRealTimeMaterialPricing = (state) =>
  getScope(state).realTimeMaterialPricing;
